import { titleize } from 'inflection';

export const formatTargetingType = (targetingType?: string | null) => titleize(targetingType ?? '-');
